// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .label-doctype {
         color: #777;
         display: block;
         font-size: 13px;
         font-weight: 400;
         margin: 15px 0 0;
         padding-bottom: 3px;
      }

      input, textarea, select {
         background: transparent;
         border: 1px solid #e5e5e5;
         border-radius: 2px;
         display: block;
         font-size: 13px;
         outline: none;
         padding: 4px;
         resize: none;
         width: 100%;
      }

      mat-select {
         width: 100%
      }

      .mandatory {
         color: #ef5350;
      }

      input[required], select[required] {
         border-color: rgba(0, 178, 201, .5);
      }

      .constraints {
         color: #999;
         font-size: 12px;
         font-style: italic;
      }
   `, "",{"version":3,"sources":["webpack://./src/app/shared/doctype.component.ts"],"names":[],"mappings":";MACM;SACG,WAAW;SACX,cAAc;SACd,eAAe;SACf,gBAAgB;SAChB,gBAAgB;SAChB,mBAAmB;MACtB;;MAEA;SACG,uBAAuB;SACvB,yBAAyB;SACzB,kBAAkB;SAClB,cAAc;SACd,eAAe;SACf,aAAa;SACb,YAAY;SACZ,YAAY;SACZ,WAAW;MACd;;MAEA;SACG;MACH;;MAEA;SACG,cAAc;MACjB;;MAEA;SACG,mCAAmC;MACtC;;MAEA;SACG,WAAW;SACX,eAAe;SACf,kBAAkB;MACrB","sourcesContent":["\n      .label-doctype {\n         color: #777;\n         display: block;\n         font-size: 13px;\n         font-weight: 400;\n         margin: 15px 0 0;\n         padding-bottom: 3px;\n      }\n\n      input, textarea, select {\n         background: transparent;\n         border: 1px solid #e5e5e5;\n         border-radius: 2px;\n         display: block;\n         font-size: 13px;\n         outline: none;\n         padding: 4px;\n         resize: none;\n         width: 100%;\n      }\n\n      mat-select {\n         width: 100%\n      }\n\n      .mandatory {\n         color: #ef5350;\n      }\n\n      input[required], select[required] {\n         border-color: rgba(0, 178, 201, .5);\n      }\n\n      .constraints {\n         color: #999;\n         font-size: 12px;\n         font-style: italic;\n      }\n   "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
